/* eslint-disable class-methods-use-this */
import CollectionApi from 'client/api/v2/CollectionApi';

class PasswordManagerUserApi extends CollectionApi {
  constructor() {
    super('/api/v2/passwordmanager/items', {
      skip: 0,
      limit: 10,
      sort: 'nickname', // Prepend with a '-' to reverse default sort direction
      search: '',
    });
  }

  setSearchTerm(params, searchTerm) {
    if (params) {
      if (searchTerm) {
        // eslint-disable-next-line no-param-reassign
        params.search = searchTerm;
      } else {
        // eslint-disable-next-line no-param-reassign
        delete params.search;
      }
    }
  }

  /**
   * items could be fetched for:
   * user: /api/v2/passwordmanager/users/{id}/items
   */
  setBaseUrl(url) {
    this.baseUrl = url;
  }

  get() {
    throw new Error('method not implemented');
  }

  create() {
    throw new Error('method not implemented');
  }

  delete() {
    throw new Error('method not implemented');
  }

  update() {
    throw new Error('method not implemented');
  }

  patch() {
    throw new Error('method not implemented');
  }
}

export default new PasswordManagerUserApi();
